// GENERAL
import React from "react";

// COMPONENTS
import { BaseText } from "../../../../../components";
import { StandaloneItem, Bundle } from "../index";

// TYPES
import {
	ApprovalOrderItemsProps,
	OrderSingleItemTypes,
	FormattedSelectedBundles,
} from "../types";

const ApprovalOrderItems: React.FC<ApprovalOrderItemsProps> = ({
	fields,
	selectedBundles,
	selectedSingleItems,
	hostName,
	currencyCharacter,
}) => {
	///// TEXT FROM FIELDS /////
	const orderItemsHeading = fields?.orderItems.headings[0].label;

	//// CONDITIONAL VARS ////
	const orderHasItems =
		selectedBundles.length > 0 || selectedSingleItems.length > 0;

	return (
		<div className="w-full" data-testid="approval-order-items">
			<div className="text-left mb-2">
				{orderHasItems && (
					<BaseText
						text={orderItemsHeading}
						size="text-base"
						color="text-gray-700"
						fontFamily="font-inter-semibold font-semibold"
						tag="h3"
					/>
				)}
			</div>
			{selectedSingleItems.map(
				(item: OrderSingleItemTypes, index: number) => (
					<StandaloneItem
						key={`${item.uuid}-${index}`}
						item={item}
						fields={fields}
						hostName={hostName}
						currencyCharacter={currencyCharacter}
					/>
				),
			)}
			{selectedBundles.map(
				(bundle: FormattedSelectedBundles, index: number) => (
					<Bundle
						key={`${bundle.uuid}-${index}`}
						orderBundle={bundle as any}
						fields={fields}
						hostName={hostName}
						currencyCharacter={currencyCharacter}
					/>
				),
			)}
		</div>
	);
};

export default ApprovalOrderItems;
